import { createSlice } from "@reduxjs/toolkit";
import { profile_update_passwordThunk } from "./thunk";

export const initialState = {
  profileUpdatePasswordData: [],
  profileUpdatePasswordError: {
    code: null,
    message: "",
    data: null,
  },
  profileUpdatePasswordLoading: false,
};

const Profile_Update_Password = createSlice({
  name: "Profile_Update_Password",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(profile_update_passwordThunk.pending, (state) => {
      state.profileUpdatePasswordLoading = true;
      state.profileUpdatePasswordError =
        initialState.profileUpdatePasswordError;
    });
    builder.addCase(profile_update_passwordThunk.fulfilled, (state, action) => {
      state.profileUpdatePasswordData = action.payload.data;
      state.profileUpdatePasswordLoading = false;
    });
    builder.addCase(profile_update_passwordThunk.rejected, (state, action) => {
      state.profileUpdatePasswordError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null,
      };
      state.profileUpdatePasswordLoading = false;
    });
  },
});

export const { apiRequest, apiError } = Profile_Update_Password.actions;

export default Profile_Update_Password.reducer;
